import React, { useState } from 'react';
import { Menu, X, Terminal } from 'lucide-react';
interface NavbarProps {
  setIsFormOpen: (isOpen: boolean) => void;
}
export const Navbar = ({
  setIsFormOpen
}: NavbarProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <nav className="bg-white shadow-sm sticky top-0 z-10" data-id="element-250">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-251">
        <div className="flex justify-between h-16" data-id="element-252">
          <div className="flex items-center" data-id="element-253">
            <Terminal className="h-8 w-8 text-indigo-600" data-id="element-254" />
            <span className="ml-2 text-xl font-bold text-gray-900" data-id="element-255">
              TechAIgent
            </span>
          </div>

          {/* Desktop menu */}
          <div className="hidden md:flex items-center space-x-4" data-id="element-256">
            <a href="#features" className="text-gray-700 hover:text-indigo-600 font-medium" data-id="element-257">
              Features
            </a>
            <a href="#how-it-works" className="text-gray-700 hover:text-indigo-600 font-medium" data-id="element-258">
              How It Works
            </a>
            <a href="#demos" className="text-gray-700 hover:text-indigo-600 font-medium" data-id="element-259">
              Demos
            </a>
            <a href="#pricing" className="text-gray-700 hover:text-indigo-600 font-medium" data-id="element-260">
              Pricing
            </a>
            <a href="#investors" className="text-gray-700 hover:text-indigo-600 font-medium" data-id="element-261">
              Investors
            </a>
            <div className="flex items-center space-x-4" data-id="element-262">
              <button onClick={() => setIsFormOpen(true)} className="bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700 transition" data-id="element-263">
                Join Waitlist
              </button>
              <a href="#contact" className="bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700 transition" data-id="element-264">
                Contact
              </a>
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="flex items-center md:hidden" data-id="element-265">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-gray-500 hover:text-gray-700 focus:outline-none" data-id="element-266">
              {isMenuOpen ? <X className="h-6 w-6" data-id="element-267" /> : <Menu className="h-6 w-6" data-id="element-268" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isMenuOpen && <div className="md:hidden bg-white" data-id="element-269">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-270">
            <a href="#features" className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-indigo-600" onClick={() => setIsMenuOpen(false)} data-id="element-271">
              Features
            </a>
            <a href="#how-it-works" className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-indigo-600" onClick={() => setIsMenuOpen(false)} data-id="element-272">
              How It Works
            </a>
            <a href="#demos" className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-indigo-600" onClick={() => setIsMenuOpen(false)} data-id="element-273">
              Demos
            </a>
            <a href="#pricing" className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-indigo-600" onClick={() => setIsMenuOpen(false)} data-id="element-274">
              Pricing
            </a>
            <a href="#investors" className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-indigo-600" onClick={() => setIsMenuOpen(false)} data-id="element-275">
              Investors
            </a>
            <div className="space-y-1" data-id="element-276">
              <button onClick={() => {
            setIsFormOpen(true);
            setIsMenuOpen(false);
          }} className="w-full text-left px-3 py-2 text-base font-medium bg-indigo-600 text-white rounded-md hover:bg-indigo-700 transition" data-id="element-277">
                Join Waitlist
              </button>
              <a href="#contact" className="block px-3 py-2 text-base font-medium bg-indigo-600 text-white rounded-md hover:bg-indigo-700 transition" onClick={() => setIsMenuOpen(false)} data-id="element-278">
                Contact
              </a>
            </div>
          </div>
        </div>}
    </nav>;
};